module.exports = __webpack_public_path__ + "assets/img/step3.0c56ce3c.png";